import * as React from 'react';
export const useFloatingNav = (
  navRef: React.MutableRefObject<null> | undefined,
) => {
  const observerRef = React.useRef<IntersectionObserver | null>(null);
  const [isFloating, setIsFloating] = React.useState(false);

  React.useEffect(() => {
    if (navRef?.current) {
      observerRef.current?.observe(navRef?.current);
    }

    return () => {
      observerRef.current?.disconnect();
    };
  }, [navRef]);

  React.useEffect(() => {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      const topOfNav = document.querySelector('#top-of-nav');

      if (topOfNav) {
        observerRef.current = new IntersectionObserver((entries) => {
          setIsFloating(!entries[0].isIntersecting);
        });

        observerRef.current.observe(topOfNav);
      }
    }

    return () => {
      observerRef.current?.disconnect();
    };
  });

  return {
    isFloating,
  };
};
